<template>
  <el-dialog
    :visible.sync="approvalVisiable"
    :center="true"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    custom-class="approval_box"
  >
    <span slot="title" class="dialog-title">
      <span v-if="type === 'approve'">
        <i
          class="el-icon-success"
          style="font-size: 18px; color: #008748; font-weight: 100"
        ></i>
        {{ title || $t('popup.approve') }}
      </span>
      <span v-else>
        <i
          class="el-icon-error"
          style="font-size: 18px; color: #e40030; font-weight: 100"
        ></i>
        {{ title || $t('popup.reject') }}
      </span>
    </span>
    <el-form ref="form" :model="form" :rules="changeRules">
      <el-form-item prop="comment">
        <el-input
          type="textarea"
          :rows="5"
          resize="none"
          maxlength="500"
          :placeholder="placeholder"
          v-model="form.comment"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        round
        size="medium"
        @click="confirmApproval"
        :disabled="disabled"
        >{{ $t('btn.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import language from '@/util/language';

export default {
  name: 'Index',
  props: {
    type: {
      type: String,
      require: true
    },
    callBack: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    valid: {
      type: Boolean,
      require: false
    },
    approvePlaceholder: {
      type: String
    },
    rejectPlaceholder: {
      type: String
    },
    title: {
      // 弹出框的 title
      type: String
    }
  },
  data() {
    return {
      approvalVisiable: false,
      disabled: false,
      form: {
        comment: ''
      }
    };
  },
  created() {},
  methods: {
    async confirm(param) {
      this.disabled = true;
      if (this.callBack) {
        const [err, data] = await this.$awaitWrap(this.callBack(param));
      }
      this.disabled = false;
      this.close();
    },
    confirmApproval() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.confirm(this.form.comment);
        }
      });
    },
    close() {
      this.approvalVisiable = false;
      this.disabled = false;
    }
  },
  computed: {
    // 默认的提示信息，如果传入了 approvePlaceholder 或者 rejectPlaceholder，使用传入的值，没有传入使用默认值，默认值需要根据 valid true 或者false 增加选填必填提示
    placeholder: function () {
      let placeholder = '';
      const { approvePlaceholder, rejectPlaceholder } = this;
      if (approvePlaceholder || rejectPlaceholder) {
        // 存在使用传入的值
        placeholder = approvePlaceholder || rejectPlaceholder;
      } else {
        // 不存在使用默认的值
        placeholder =
          this.type === 'approve'
            ? this.$t('popup.approve_placeholder')
            : this.$t('popup.reject_placeholder');
        // 根据是否必填增加 optional 或者 required 信息,reject 情况下一定必填，valid 为 true 一定必填
        if (this.valid || this.type === 'reject') {
          placeholder += '(' + this.$t('popup.required') + ')';
        } else {
          placeholder += '(' + this.$t('popup.optional') + ')';
        }
      }
      return placeholder;
    },
    changeRules: function () {
      let rules;
      if (this.type === 'reject' || this.valid) {
        rules = {
          comment: [
            { required: true, message: 'Comment is required', trigger: 'blur' }
          ]
        };
      } else {
        rules = { comment: [] };
      }
      return rules;
    }
  }
};
</script>

<style lang="less">
.approval_box {
  width: 450px;
  // height: 300px;
  border-radius: 10px;

  /deep/ .el-dialog__header {
    height: 60px;
    font-size: 14px;
    font-weight: bolder;
    line-height: 60px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .dialog-footer {
    /deep/ .el-button {
      margin: 0 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?768928cc